import { useRollbar as goRollbar } from '@openx/utils/hooks/rollbarIntegration/useRollbar.ts';
import { EN_LOCALE, JP_LOCALE } from '@openx/utils/i18n/constants.ts';
import { i18nConfigure } from '@openx/utils/i18n/i18n.ts';
import { getCurrentLocale } from '@openx/utils/i18n/locale.ts';
import { initGA } from '@openx/utils/lib/googleAnalytics.ts';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { GA_ORIGIN_DOMAIN, GA_TRACKING_ID } from './config.ts';
import { initialize as initializeGoogleIntegration } from './modules/googleIntegration/googleIntegration.ts';
import translationJP from './modules/i18n/locales/jp/translations.json';

const { initialize } = goRollbar('CTA');

initialize();
initializeGoogleIntegration();
initGA(GA_TRACKING_ID, !window.origin.includes(GA_ORIGIN_DOMAIN));

i18nConfigure({
  lng: getCurrentLocale(),
  resources: {
    [JP_LOCALE]: {
      translation: translationJP,
    },
  },
  supportedLngs: [EN_LOCALE, JP_LOCALE],
});

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(<App />);
